import { Component, OnInit, Input, inject } from '@angular/core';
import { FundFeeDialogComponent } from '../fund-fee-dialog/fund-fee-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FundFeeLookupService } from '../fund-fee-lookup.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-fund-fee-handler',
  templateUrl: './fund-fee-handler.component.html',
  styleUrls: ['./fund-fee-handler.component.scss'],
  imports: [MatButtonModule, MatIconModule, CommonModule],
})
export class FundFeeHandlerComponent implements OnInit {
  private dialog = inject(MatDialog);
  private feeSvc = inject(FundFeeLookupService);

  @Input() fieldData;
  @Input() varSet;
  @Input() group;
  dialogRef;
  buttonLabel: string;

  buttonColor;

  ngOnInit() {
    this.buttonLabel =
      this.fieldData.props?.options?.find(opt => opt.value === '2')?.label ||
      'Look up Fund Fees';
    this.buttonColor = 'primary';
  }

  triggerLookUp(e) {
    e.preventDefault();
    if (this.fieldData.type === 'custom-manual-lookup-document') {
      this.fieldData.formControl.setValue(2);
    }
    this.openLookUpDialog();
  }

  openLookUpDialog() {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(FundFeeDialogComponent, {
        panelClass: 'fund-fee-dialog',
        minHeight: '50vh',
        width: '70vw',
      });
      // dialogRef.afterOpened().subscribe(x => { this.loading = false; });
      this.dialogRef.afterClosed().subscribe(result => {
        if (result && result !== 'cancel') {
          const data = {};
          data['groupIndex'] = this.fieldData.parent.form.controls.indexOf(
            this.fieldData.form
          );
          data['results'] = result;
          data['varset'] = this.varSet;
          data['group'] = this.group;

          this.feeSvc.calculationData(data);
        }
        this.dialogRef = null;
      });
    }
  }
}
